module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-laurel-backcountry.b864211.png";